import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import benchTube from '@learningblocks/exp-constants/lib/Images/benchTube.svg';
import {TubeTooltip} from './TubeTooltip';

import style from './style.module.scss';

const INSERT_ITEM_ID = 'INSERT_ITEM_ID';

export function TubeSlots(props) {
  const onDragOver = (event) => event.preventDefault();

  const onDrop = (event) => {
    const insertItemId = parseInt(event.dataTransfer.getData(INSERT_ITEM_ID));
    const tubeSlotId = event.target.id;
    props.onTubeDrop({tubeId: insertItemId, tubeSlotId: tubeSlotId});
  };

  const renderTube = (slotId) => {
    const tube = props.slots[slotId].tube;
    return tube ? (
      <Image src={benchTube} className={style.tubeSlots_tube} />
    ) : null;
  };

  return (
    <>
      <div className={style.tubeSlots}>
        <div
          className={style.tubeSlots_one}
          onDragOver={onDragOver}
          onDrop={onDrop}>
          <div className={style.tubeSlots_one_tube} id='0'>
            {renderTube(0)}
          </div>
        </div>
        <div
          className={style.tubeSlots_two}
          onDragOver={onDragOver}
          onDrop={onDrop}>
          <div className={style.tubeSlots_two_tube} id='1'>
            {renderTube(1)}
          </div>
        </div>
        <div
          className={style.tubeSlots_three}
          onDragOver={onDragOver}
          onDrop={onDrop}>
          <div className={style.tubeSlots_three_tube} id='2'>
            {renderTube(2)}
          </div>
        </div>
        <div
          className={style.tubeSlots_four}
          onDragOver={onDragOver}
          onDrop={onDrop}>
          <div className={style.tubeSlots_four_tube} id='3'>
            {renderTube(3)}
          </div>
        </div>
      </div>
      <TubeTooltip
        className={style.tubeSlots_tooltip}
        tubeTooltip={props.tubeTooltip}
        isModalOpen={props.isModalOpen}
        toggleModal={props.toggleModal}
        tubeTooltipDisplay={props.tubeTooltipDisplay}
        tubeTooltipRemove={props.tubeTooltipRemove}
        filledSlots={props.filledSlots}
        removeTubeFromHeatblock={props.removeTubeFromHeatblock}
        isHeating={props.isHeating}
      />
    </>
  );
}

TubeSlots.propTypes = {
  /**
   * Modal window to open when clicking on the HeatBlock
   */
  isModalOpen: PropTypes.bool.isRequired,
  /**
   * Function to triger the modalwindow,to change the state 'isModalOpen'
   */
  toggleModal: PropTypes.func,
  /**
   * Boolean used to display the tube properties on hover
   */
  tubeTooltip: PropTypes.bool,
  /**
   * Function to invoke tube tooltip
   */
  tubeTooltipDisplay: PropTypes.func,
  /**
   * Function to remove tube tooltip
   */
  tubeTooltipRemove: PropTypes.func,
  /**
   * Filled slots is a interger which stores how many tubes are filled in heatblock
   */
  filledSlots: PropTypes.number,
  /**
   * Function used to remove the testtubes from Heatblock
   */
  removeTubeFromHeatblock: PropTypes.func,
  /**
   * Slots are the array which represent the filing of tube
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * It defines the number of slot in the heatblock
       */
      slotId: PropTypes.number.isRequired,
      /**
       * It defines the number of slot in the heatblock
       */
      tube: PropTypes.bool,
    })
  ).isRequired,
  /**
   * Function to add the tube to the heatblock
   */
  onTubeDrop: PropTypes.func,
  /**
   * It is used to ideantify if the testtube is heating or not
   */
  isHeating: PropTypes.bool,
};
